import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { Icon } from '../Icon/Icon';
export var LoadingIndicator = function (_a) {
    var style = _a.style, _b = _a.className, className = _b === void 0 ? 'fa-4x' : _b, _c = _a.color, color = _c === void 0 ? '#61A9D0' : _c;
    return (React.createElement(Icon, { style: style, className: className, icon: faSpinnerThird, color: color, spin: true, "data-testid": "loading-indicator" }));
};
